import styled from 'styled-components';
import sizes from 'styles/sizes';
import { BrandCode } from 'types';

export const ItineraryMapContainer = styled.div<any>`

  display: ${ ({ showMap }) => showMap ? 'block' : 'none'};
  margin-top: 20px;

  && span {
    position: relative !important;
  }

  img {
    position: relative !important;
    height: auto !important;
  }
  ${({ theme }) => ({
		[BrandCode.RoyalCaribbean]: `

			@media (min-width: ${sizes.media.tabletMinWidth}px) {        
        margin-top: 30px;
			}
		`,
	})[theme.brandCode]}

`;